import { Flex } from "@aws-amplify/ui-react"
import { useState, type ChangeEvent } from "react"

import "./ButtonWithIcon.css"

interface ButtonWithIconProps {
  title: React.ReactNode
  icon: React.ReactNode
  className?: string
  onClick?: () => void
  isDisabled?: boolean | undefined
}
export const ButtonWithIcon = ({
  title,
  className,
  icon,
  onClick,
  isDisabled = false,
}: ButtonWithIconProps) => {
  const classNames = ["button-with-icon"]
  if (className) {
    classNames.push(className)
  }
  if (isDisabled) {
    classNames.push("disabled")
  }
  return (
    <Flex
      alignItems="center"
      className={classNames.join(" ")}
      onClick={onClick}
    >
      {title}
      {icon}
    </Flex>
  )
}

interface SelectButtonWithIconProps {
  options: {
    value: string
    text: string
  }[]
  selected?: string
  icon: React.ReactNode
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void
  className?: string
}
export const SelectButtonWithIcon = ({
  options,
  selected,
  className,
  onChange,
  icon,
}: SelectButtonWithIconProps) => {
  const [selectedOption, setSelectedOption] = useState<string>(selected || "")
  return (
    <Flex
      alignItems="center"
      className={`button-with-icon select-button-with-icon ${className || ""}`}
    >
      <select
        value={selectedOption}
        onChange={(e) => {
          setSelectedOption(e.target.value)
          if (onChange) {
            onChange(e)
          }
        }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.text}
          </option>
        ))}
      </select>
      {icon}
    </Flex>
  )
}
